import { cn } from '@/lib/utils'
import React from 'react'

interface ToggleButtonsProps {
  options: string[]
  optionsContent: React.ReactNode[]
  selectedOption: string
  onOptionClick: (option: string) => void
  size?: 'sm' | 'md'
}

const ToggleButtons: React.FC<ToggleButtonsProps> = ({
  options,
  optionsContent,
  selectedOption,
  onOptionClick,
  size = 'md'
}) => {
  return (
    <div className="border-outline-variant rounded-xs flex h-full flex-row border">
      {options.map((option, index) => (
        <button
          key={option}
          onClick={() => onOptionClick(option)}
          className={cn(
            size === 'sm' ? 'p-xs' : 'py-xs px-sm',
            'relative',
            size === 'md'
              ? selectedOption === option // MD styling
                ? `text-on-surface bg-surface fill-on-surface border-outline-variant ${index === 0 ? 'border-r' : 'border-l'}`
                : 'text-on-surface-variant fill-on-surface-variant bg-surface-container hover:text-on-surface hover:fill-on-surface hover:bg-surface'
              : selectedOption === option // SM styling
                ? `text-on-surface bg-surface fill-on-surface border-outline-variant ${index === 0 ? 'border-r' : 'border-l'}`
                : 'text-on-surface-variant fill-on-surface-variant bg-surface hover:text-on-surface hover:fill-on-surface hover:bg-surface-container opacity-30 transition-colors hover:opacity-100'
          )}
        >
          {optionsContent[index]}
        </button>
      ))}
    </div>
  )
}

export default ToggleButtons
